import type { AxiosError, AxiosResponse, RawAxiosResponseHeaders } from 'axios';
import { get } from 'lodash-es';
import { CodeBlock } from 'react-code-blocks';

import { ResponseCode } from '@page/explorer/components/response-code/response-code';
import { CardExplorer } from '@page/explorer/explorer.style';

import { Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

import { ResponseTypeTitle, themeCodeBlock, TitleWrapper } from './explorer-response.style';

interface ExplorerResponseProps {
  response: AxiosResponse | AxiosError;
}

export const ExplorerResponse = ({ response }: ExplorerResponseProps) => {
  const headers = get(
    response as AxiosError,
    ['response', 'headers'],
    get(response as AxiosResponse, ['headers'], {}),
  ) as RawAxiosResponseHeaders;

  const data = get(
    response as AxiosError,
    ['response', 'data'],
    get(response as AxiosResponse, ['data'], {}),
  ) as Record<string, string>;

  const status = get(response as AxiosError, ['response', 'status'], get(response as AxiosResponse, ['status'], 0));

  return (
    <CardExplorer>
      <TitleWrapper>
        <Title color={ColorEnum.Black100} level={5} mb={8} weight={300}>
          Response
        </Title>
        <ResponseCode code={status} />
      </TitleWrapper>
      {Object.keys(headers).length > 0 && (
        <>
          <ResponseTypeTitle color={ColorEnum.Black100} level='l' mb={8} weight={300}>
            Response headers
          </ResponseTypeTitle>
          <CodeBlock language='json' text={JSON.stringify(headers, null, 2)} {...themeCodeBlock} />
        </>
      )}
      <>
        <ResponseTypeTitle color={ColorEnum.Black100} level='l' mb={8} weight={300}>
          Response data
        </ResponseTypeTitle>
        <CodeBlock language='json' text={JSON.stringify(data ?? {}, null, 2)} {...themeCodeBlock} />
      </>
    </CardExplorer>
  );
};
